import React, { useState } from 'react'
import {Button, Checkbox,FormControlLabel} from '@mui/material'
import { store } from './redux/store'

export default function Code(props) {
  const [minlb,setminlb]=useState("")
  const [aprfx,setaprfx]=useState("")
  const [shpcopied,setshpcopied]=useState("copy shapecode")
  const [animmcopied,setanimmcopied]=useState("copy animations")
  const [kfrcopied,setkfrcopied]=useState("copy keyframes")
  
  
  const animm=`.${props.msg} {
    animation: ${props.msg+' '+props.Tdata[0]+'s'+' '+props.bzval+' '+props.Tdata[1]+'s '+props.Tdata[2]+' '+props.Tdata[3]+' '+props.Tdata[4]};
  }`
  const kfr=props.apidata.data[0][props.send2code];
  const shp=props.shpval.data[0][props.shpkey];
  const dt=new Date()
  
  return (
    <div className='flex-center code' id='codeid'>
      <div className='codechkbox'>
        {/* <FormControlLabel control={<Checkbox defaultChecked onChange={(e)=>{setminlb(e)}} />} label="minify" />
        <FormControlLabel control={<Checkbox defaultChecked onChange={(e)=>{setaprfx(e)}}/>} label="aprfx" /> */}
      </div>
      <Button id='copybtn3' variant='contained' size='small'  onClick={()=>{navigator.clipboard.writeText(shp);setshpcopied("copied");setTimeout(()=>{setshpcopied("copy shapecode")}, 1500);}} >{shpcopied}</Button>
      <Button id='copybtn1' variant='contained' size='small'  onClick={()=>{navigator.clipboard.writeText(animm);setanimmcopied("copied");setTimeout(()=>{setanimmcopied("copy animations")}, 1500);}}>{animmcopied}</Button>
      <Button id='copybtn2' variant='contained' size='small'   onClick={()=>{navigator.clipboard.writeText(kfr);setkfrcopied("copied");setTimeout(()=>{setkfrcopied("copy keyframes")}, 1500);}}>{kfrcopied}</Button>
      <textarea className="codeBox" id="shapeCode" spellCheck="false" autoCapitalize="none" autoCorrect="off" autoComplete="off" wrap="off" readOnly="" value={animm}></textarea>
      <textarea className="codeBox" id="selCode" spellCheck="false" autoCapitalize="none" autoCorrect="off" autoComplete="off" wrap="off" readOnly="" value={`
      ***************** !CLICK ON THE LEFT-MOST NAVIGATION IF CODE IS UNDEFINED *********************
      
/* ----------------------------------------------
 * Generated by Sclib on ${dt.toUTCString()}
 * w: https://sclib-ts5m.onrender.com/ 
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation ${props.msg}
 * ----------------------------------------
 */
${kfr}`}></textarea>
      <textarea className="codeBox" id="kfrCode" spellCheck="false" autoCapitalize="none" autoCorrect="off" autoComplete="off" wrap="off" readOnly="" value={shp} ></textarea>
    </div>
  )
}
